import ReactDOM from "react-dom/client"
import { App } from "./App"
import "./styles/globals.css"

// NOTE: StrictMode is intentionally disabled. Its dev-only double-mount breaks
// react-pdf (the first unmount aborts the PDF load, the remount then hangs), so
// the PDF never rendered in local dev while prod (no double-mount) was fine.
ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
